import ErrorPopIcon from "reusable/icons/ErrorPopIcon"
import ClassicPopUp from "./ClassicPopUp"

type ErrorInFormPopupProps = {
  open: boolean
  onClose: () => void
}

const ErrorInFormPopup = ({ open, onClose }: ErrorInFormPopupProps) => {
  return (
    <ClassicPopUp
      icon={<ErrorPopIcon />}
      open={open}
      title="מצטערים, משהו השתבש"
      text="הפנייה לא נשלחה אלינו,
      כדאי לנסות שוב"
      onClose={onClose}
    />
  )
}

export default ErrorInFormPopup
